import { Component, h, Prop } from '@stencil/core'

@Component({
  tag: 'envc-table-of-contents',
  styleUrl: 'envc-table-of-contents.scss',
  shadow: true
})

export class EnvcTableOfContents {
  @Prop() backgroundColor: string
  @Prop() tableTitle: string

  render() {
    return (
      <div class={this.backgroundColor}>
        {
          this.tableTitle && (
            <h3>{this.tableTitle}</h3>
          )
        }

        <ul>
          <slot></slot>
        </ul>
      </div>
    )
  }
}
